export const ANALYTICS_EVENT_ENVIRONMENTS = {
  NI: 'NI',
};
